import dayjs from 'dayjs';

const relativeTime = require('dayjs/plugin/relativeTime');
const isToday = require('dayjs/plugin/isToday');
const utc = require('dayjs/plugin/utc');
const objectSupport = require('dayjs/plugin/objectSupport');

dayjs.extend(utc);
dayjs.locale('uk');
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(objectSupport);

const UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
const UI_DATE_TIME_FORMAT_UA = 'DD.MM.YYYY HH:mm';

export const getDateAndTimeFormatted = (date) => {
    const dateFormat = 'YYYY-MM-DD';
    const timeFormat = 'HH:mm:ss';
    const parsedDate = dayjs.utc(date).local();

    return {
        date: parsedDate.format(dateFormat),
        time: parsedDate.format(timeFormat),
    };
};

export const getRelativeTimeToNow = (date) => {
    const parsedDate = dayjs.utc(date).local();
    const relativeTimeValue = dayjs().to(parsedDate);

    return relativeTimeValue.charAt(0).toUpperCase() + relativeTimeValue.slice(1);
};

export const getDateTimeFormattedForUi = (date) => {
    return dayjs.utc(date).local().format(UI_DATE_TIME_FORMAT_UA);
};

export const getSmartDateTimeForUi = (date, relativeThresholdHours = 24) => {
    const parsedDate = dayjs.utc(date).local();

    if (!parsedDate.isValid()) {
        return '';
    }

    const diffInHours = Math.abs(dayjs().diff(parsedDate, 'hour'));

    if (diffInHours < relativeThresholdHours) {
        return getRelativeTimeToNow(date);
    }

    return getDateTimeFormattedForUi(date);
};

export const getDifferenceInDays = (date) => {
    return Math.floor(dayjs().diff(dayjs.utc(date).local(), 'days'));
};

export const toUtcFormat = (date) => {
    return dayjs.utc(date).format(UTC_FORMAT);
};

export const utcStartOfDay = (date) => {
    const startOfLocalDay = new Date(date);

    startOfLocalDay.setHours(0, 0, 0, 0);
    return startOfLocalDay.toISOString();
};

export const utcEndOfDay = (date) => {
    const endOfLocalDay = dayjs(date);

    const isToday = endOfLocalDay.isToday();

    if (isToday) {
        return endOfLocalDay.subtract(1, 'minute').toISOString();
    }

    if (!isToday) {
        return endOfLocalDay.set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 999).toISOString();
    }
};
